import type { ModalProps } from 'antd';
import { Modal, Spin, Typography } from 'antd';

const { Text } = Typography;

const DownloadingFileModal = (props: ModalProps) => (
  <Modal {...props} centered closable={false} footer={null}>
    <div className="flex flex-row justify-center items-center gap-x-2 py-2">
      <Spin />
      <Text className="text-sm text-functional-black">Downloading file</Text>
    </div>
  </Modal>
);

export default DownloadingFileModal;
